<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex>
        <slot name="page-header" />
        <v-row class="ma-0">
          <v-col class="pa-0 pr-4">
            <v-row no-gutters>
              <v-col>
                <slot name="history-filter" />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <slot name="history-list-toolbar" />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <slot name="history-list" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HistoryLayout extends Vue {
}
</script>

<style lang="scss" scoped>
@import './styles/history-layout.scss';
</style>
